import type { ProjectGraphNode, ProjectGraphRuleFinding } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { Link } from '../../components/Link';
import { evidenceLinks } from './evidenceLinks';
import { ruleStatusColor } from './findings';

/** The rule findings about the selected node: status, title and rule, the detail, the missing records, and evidence. */
export function NodeRuleFindings({
  ruleFindings,
  nodesById,
}: {
  ruleFindings: ProjectGraphRuleFinding[];
  nodesById: ReadonlyMap<string, ProjectGraphNode>;
}) {
  if (ruleFindings.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      <div className="mt-2 font-medium">Rule findings</div>
      <ul className="flex flex-col gap-2">
        {ruleFindings.map((finding) => {
          const links = evidenceLinks(finding.evidence, nodesById);
          return (
            <li key={finding.id} className="flex flex-col gap-0.5">
              <div className="flex flex-wrap items-center gap-2">
                <Badge color={ruleStatusColor(finding.status)}>{finding.status}</Badge>
                <span className="break-words">{finding.title}</span>
                <span className="text-zinc-500 dark:text-zinc-400">{finding.kind}</span>
              </div>
              {finding.detail && (
                <p className="text-sm break-words text-zinc-600 dark:text-zinc-300">{finding.detail}</p>
              )}
              {finding.missing && finding.missing.length > 0 && (
                <p className="text-sm break-words text-zinc-500 dark:text-zinc-400">
                  missing: {finding.missing.map((item) => item.documentType).join(', ')}
                </p>
              )}
              {links.length > 0 && (
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                  <span className="text-sm text-zinc-500 dark:text-zinc-400">evidence:</span>
                  {links.map((link) => (
                    <Link key={link.key} to={link.to} target="_blank" rel="noopener noreferrer">
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
